/* eslint-disable react/jsx-props-no-spreading */
import React, {
  useState,
  useEffect,
  createContext,
  useContext,
  useMemo,
} from "react";

const TimerContext = createContext();

export const TimerProvider = ({ children }) => {
  const [seconds, setSeconds] = useState(0);
  const [timeActive, setTimerActive] = useState(false);
  const [shouldStopTimer, setShouldStopTimer] = useState(false);

  useEffect(() => {
    let intervalId;
    if (timeActive && !shouldStopTimer) {
      intervalId = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds + 1);
      }, 1000);
    }
    if (!timeActive && intervalId) {
      clearInterval(intervalId);
    }
    return () => intervalId && clearInterval(intervalId);
  }, [timeActive]);

  const startTimer = () => {
    setTimerActive(true);
  };

  const pauseTimer = () => {
    setTimerActive(false);
  };

  const stopTimer = () => {
    setTimerActive(false);
    setShouldStopTimer(true);
    setSeconds(0);
  };

  // const value = { seconds, setSeconds, stopTimer, setStopTimer };
  const contextValue = useMemo(
    () => ({ seconds, setSeconds, startTimer, pauseTimer, stopTimer }),
    [seconds, setSeconds, startTimer, pauseTimer, stopTimer],
  );
  return (
    <TimerContext.Provider value={contextValue}>
      {children}
    </TimerContext.Provider>
  );
};

export const useTimer = () => {
  const context = useContext(TimerContext);
  if (!context) {
    throw new Error('useTimer must be used within a TimerProvider');
  }
  return context;
};

export const withTimer = (Component) => (props) => (
  <TimerContext.Consumer>
    {(context) => <Component {...props} themeContext={context} />}
  </TimerContext.Consumer>
);
